/* eslint-disable import/prefer-default-export */
import { unionWith } from 'lodash';

export const optionalRequiredFormFieldsFallback = (optionalFieldList = {}, requiredFieldList = {}, defaultConfig) => {
    return {
        displayedFields: {
            ...defaultConfig.displayedFields,
            guestDetails: unionWith(optionalFieldList, requiredFieldList)
        },
        requiredFields: {
            ...defaultConfig.requiredFields,
            guestDetails: requiredFieldList
        }
    };
};



// WEBPACK FOOTER //
// ./src/utils/configurationFallbacks.js